module.exports = __webpack_public_path__ + "img/double_plug_hook_box2.8b397647.png";